import { getCurrentAdmin } from '../src/services/auth'

export async function validateSession() {
  const token = sessionStorage.getItem('adminToken')
  if (!token) return false

  try {
    await getCurrentAdmin()
    return true
  } catch (error) {
    return false
  }
}
